import { _axios } from '../plugins/axios'
import { globals } from '../main.js'
import Configuration from '@/configuration'

const Vue = {}
Vue.axios = _axios

function makeRequest(callback) {
  return globals.$authService
    .getAccessToken()
    .then((response) => {
      callback(response)
    })
    .catch(function (error) {
      //Acquire token silent failure, log it and let the caller decide what to do
      new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

export default {
  async deleteNewsItem(id) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'delete',
          body: '',
          url: Configuration.value('uiEndPoint').concat(`/api/News/Delete/${id}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async getNews(communityAbbrev) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          body: '',
          url: Configuration.value('uiEndPoint').concat(`/api/News/Get/${communityAbbrev}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async getNewsForEdit() {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'get',
          body: '',
          url: Configuration.value('uiEndPoint').concat(`/api/News/GetNewsForEdit`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }
      makeRequest(axiosRequest)
    })
  },
  async save(data) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.axios({
          method: 'post',
          data: data,
          url: Configuration.value('uiEndPoint').concat('/api/News/Save'),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }
      makeRequest(axiosRequest)
    })
  }
}
